import type { TranslateFn } from './TranslateFn'
import type { AppProblemModel } from '@/services/api/AppProblemModel'
import { fieldIssueMessage } from '@/services/api/fieldIssueMessage'

/** Every field issue of a problem as its own translated message, joined in wire order; null when the problem carries none. */
export const fieldIssuesMessage = (problem: AppProblemModel, t: TranslateFn): string | null => {
  const messages = Object.values(problem.fieldIssues).flatMap((issues) =>
    issues.map((issue) => fieldIssueMessage(issue, t))
  )

  return messages.length > 0 ? messages.join(' ') : null
}
